import { useQuery } from '@tanstack/react-query'

import { MenuViewModel } from '@/types/api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

export function useLayoutMenu() {
    return useQuery<MenuViewModel>({
        queryKey: QueryKeys.Layout.LayoutMenu,
        queryFn: () => {
            return fetchRequest({ endpoint: `/layout/menu`, method: 'GET', serviceName: 'ntl' })
        },
        refetchOnMount: false,
        retryOnMount: false,
        staleTime: 100,
    })
}
